import {Directive} from '@angular/core';
import {ElementRef} from '@angular/core';
import {HostListener} from '@angular/core';
import {Input} from '@angular/core';

import {UIMenuComponent} from './menu.component';

@Directive({ selector: '[uiMenu]' })
export class UIMenuTriggerDirective {

    @Input()
    uiMenu: UIMenuComponent;

    constructor(private _elementRef: ElementRef) {
    }

    @HostListener('click')
    private _openMenu() {
        this.uiMenu.open(this._elementRef).subscribe(() => {
            this._elementRef.nativeElement.classList.remove('active');
        });
        this._elementRef.nativeElement.classList.add('active');
    }

}